import React from "react";
import { CircularProgress } from "@material-ui/core";
import { validatePermission } from "../../libs/permissions";
import { resolveEnterpriseId } from "../../libs/tenant";
import RateList from "./RateList";

// Container do módulo de Câmbio (cotação do dia: à vista + cheque 30/60/90).
// Resolve o enterprise_id do tenant, igual ao módulo de Produtos.
class Cambio extends React.Component {
  constructor(props) {
    super(props);
    this.state = { enterpriseId: null, loading: true };
  }

  componentDidMount() {
    validatePermission();
    resolveEnterpriseId()
      .then((enterpriseId) => this.setState({ enterpriseId, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center", padding: 40 }}>
          <CircularProgress />
        </div>
      );
    }

    return <RateList enterpriseId={this.state.enterpriseId} />;
  }
}

export default Cambio;
